import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface ActivateAdvisorCompanyArg {
    id: string;
}

export const ActivateAdvisorCompany = createAsyncThunk(
    'advisorCompanies/activate',
    async (arg: ActivateAdvisorCompanyArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `api/marketplace/advisor-companies/${arg.id}/activate`
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while activating the advisor company.';
            createNotification(message, 'error');
            throw new Error('Failed to activate advisor company');
        }

        createNotification('Advisor company activated.', 'success');
        return arg.id;
    }
);
